import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var DRAG_OFFSET = 0.3;
/**
 * 打平所有数组，并添加pos位置信息，
 * 方便根据expandKeys等计算节点的expand，checkedKeys计算节点checked状态
 * @param treeData [{key:'',title:'',children:[]}]
 * @param newTreeData[{key:'',title:'',children:[], pos:'', hasChildNode, level}]
 * @param level
 * @param pos
 */

export var flattenAll = function flattenAll(treeData) {
  var newTreeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var pos = arguments.length > 3 ? arguments[3] : undefined;
  var maxLevel = 0;

  var fn = function fn(treeData) {
    var newTreeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var pos = arguments.length > 3 ? arguments[3] : undefined;
    var parent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    treeData && treeData.forEach(function (item, index) {
      var _context;

      var children = item.children,
          title = item.title,
          key = item.key,
          others = __rest(item, ["children", "title", "key"]);

      item.parent = parent;

      var _pos = pos ? _concatInstanceProperty(_context = "".concat(pos, "-")).call(_context, index) : "".concat(index);

      var hasChildNode = item.isLeaf ? false : children && children instanceof Array && children.length > 0;

      var flattenNode = _extends({
        title: title,
        key: key,
        pos: _pos,
        hasChildNode: hasChildNode,
        level: level,
        parent: parent
      }, others);

      newTreeData.push(flattenNode);
      var _level = level;

      if (maxLevel < level) {
        maxLevel = level;
      }

      _level++;
      hasChildNode && fn(children, newTreeData, _level, _pos, flattenNode);
    });
    return newTreeData;
  };

  var flattenAllData = fn(treeData, newTreeData, level, pos);
  return {
    flattenAllData: flattenAllData,
    maxLevel: maxLevel
  };
};
export var getExpand = function getExpand(expandedKeys, key) {
  return expandedKeys === null || expandedKeys === void 0 ? void 0 : _includesInstanceProperty(expandedKeys).call(expandedKeys, key);
};
export var getChecked = function getChecked(checkedKeys, key) {
  return checkedKeys === null || checkedKeys === void 0 ? void 0 : _includesInstanceProperty(checkedKeys).call(checkedKeys, key);
};
export var getSelected = function getSelected(selectedKeys, key) {
  return selectedKeys === null || selectedKeys === void 0 ? void 0 : _includesInstanceProperty(selectedKeys).call(selectedKeys, key);
};
export var getHalfChecked = function getHalfChecked(halfCheckedKeys, key) {
  return halfCheckedKeys === null || halfCheckedKeys === void 0 ? void 0 : _includesInstanceProperty(halfCheckedKeys).call(halfCheckedKeys, key);
};
/**
 * 获取所有层级的父节点
 * @param data
 * @param pos
 */

var isAllParentExpand = function isAllParentExpand(data, pos) {
  var expand = true;

  while (pos.lastIndexOf('-') > -1 && expand) {
    pos = pos.substring(0, pos.lastIndexOf('-'));

    var parentNode = _findInstanceProperty(data).call(data, function (item) {
      return item.pos === pos;
    });

    expand = parentNode === null || parentNode === void 0 ? void 0 : parentNode.expand;
  }

  return expand;
};

export var getAllFilterKeys = function getAllFilterKeys(data, filterTreeNode) {
  var allFilterKeys = [];

  _filterInstanceProperty(data).call(data, function (item) {
    return filterTreeNode === null || filterTreeNode === void 0 ? void 0 : filterTreeNode(item);
  }).forEach(function (item) {
    var node = _extends({}, item);

    while (node) {
      allFilterKeys.push(node.key);
      node = node.parent;
    }
  });

  return _toConsumableArray(new _Set(allFilterKeys));
};
export var getFilterData = function getFilterData(data, filterTreeNode, isSearching) {
  var filterData = data;
  var allFilterKeys = null;

  if (isSearching) {
    allFilterKeys = getAllFilterKeys(filterData, filterTreeNode);
    filterData = _filterInstanceProperty(filterData).call(filterData, function (item) {
      return _includesInstanceProperty(allFilterKeys).call(allFilterKeys, item.key);
    });
  }

  var newData = [];
  filterData.forEach(function (item) {
    var pos = item.pos;
    var parentExpand = isAllParentExpand(filterData, pos);

    if (parentExpand) {
      newData.push(item);
    }
  });
  return newData;
};

var hasParentChecked = function hasParentChecked(data, checkedKeys) {
  var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var checked = false;

  while (pos.lastIndexOf('-') > -1 && !checked) {
    pos = pos.substring(0, pos.lastIndexOf('-'));

    var parentNode = _findInstanceProperty(data).call(data, function (item) {
      return item.pos === pos;
    });

    checked = getChecked(checkedKeys, parentNode.key);
  }

  return checked;
};

var isChild = function isChild(itemPos, pos, condition) {
  var index = itemPos.indexOf(pos);
  var str = itemPos.substr(index + pos.length, 1);

  if (_startsWithInstanceProperty(itemPos).call(itemPos, pos) && str === '-' && condition) {
    return true;
  }

  return false;
};

var hasChildCheckState = function hasChildCheckState(data, halfCheckedKeys, checkedKeys, pos, level) {
  var isInit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var childNodes = _filterInstanceProperty(data).call(data, function (item) {
    if (isInit) {
      return isChild(item.pos, pos, pos !== item.pos);
    }

    return isChild(item.pos, pos, level === item.level - 1);
  });

  var childNodesCheckedState = [];
  var childNodesHalfCheckedState = [];
  childNodes.forEach(function (item) {
    childNodesCheckedState.push(getChecked(checkedKeys, item.key));
    childNodesHalfCheckedState.push(getChecked(halfCheckedKeys, item.key));
  });
  var checked = childNodesCheckedState.some(function (item) {
    return item === true;
  });
  var halfChecked = childNodesHalfCheckedState.some(function (item) {
    return item === true;
  });
  return {
    checked: checked,
    halfChecked: halfChecked
  };
};

var allChildChecked = function allChildChecked(data, checkedKeys, pos, level, init) {
  var childNodes = _filterInstanceProperty(data).call(data, function (item) {
    if (init) {
      return isChild(item.pos, pos, pos !== item.pos);
    }

    return isChild(item.pos, pos, level === item.level - 1);
  });

  var childNodesCheckedState = [];
  childNodes.forEach(function (item) {
    childNodesCheckedState.push(getChecked(checkedKeys, item.key));
  });
  var checked = childNodesCheckedState.every(function (item) {
    return item === true;
  });
  return checked;
};

export var getMaxLevel = function getMaxLevel(data) {
  var maxLevel = 0;
  data.forEach(function (item) {
    maxLevel = item.level > maxLevel ? item.level : maxLevel;
  });
  return maxLevel;
};
/**
 *计算node的属性后返回新的 treedata
 * @param treeData  打平后的treeData [{key:'',title:'',children:[], pos:''}]
 * @param defaultExpandRoot
 * @param expandedKeys
 * @param defaultExpandAll
 */

export var getSpreadAttrData = function getSpreadAttrData(treeData, expandedKeys) {
  var newTreeData = [];
  treeData.forEach(function (item) {
    var title = item.title,
        key = item.key,
        icon = item.icon,
        disabled = item.disabled,
        checkable = item.checkable,
        pos = item.pos,
        level = item.level,
        hasChildNode = item.hasChildNode,
        selectable = item.selectable,
        others = __rest(item, ["title", "key", "icon", "disabled", "checkable", "pos", "level", "hasChildNode", "selectable"]);

    var itemExpand = getExpand(expandedKeys, key);
    var expand = itemExpand || false;
    newTreeData.push(_extends({
      title: title,
      key: key,
      level: level,
      pos: pos,
      hasChildNode: hasChildNode,
      expand: expand,
      icon: icon,
      disabled: disabled,
      checkable: checkable,
      selectable: selectable
    }, others));
  });
  return newTreeData;
};
export var addKeys = function addKeys() {
  var _context2;

  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return _Array$from(new _Set(_concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(prevKeys), _toConsumableArray(newKeys))));
};
export var getAllParentKeys = function getAllParentKeys(data) {
  var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var keys = [];

  while (pos.lastIndexOf('-') > -1) {
    pos = pos.substring(0, pos.lastIndexOf('-'));
    data.forEach(function (item) {
      if (item.pos === pos) {
        keys.push(item.key);
      }
    });
  }

  return keys;
};
export var getAllParentPos = function getAllParentPos(data) {
  var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var posArr = [];

  while (pos.lastIndexOf('-') > -1) {
    pos = pos.substring(0, pos.lastIndexOf('-'));
    data.forEach(function (item) {
      if (item.pos === pos) {
        posArr.push(item.pos);
      }
    });
  }

  return posArr;
};
export var getAllChildKeys = function getAllChildKeys(data) {
  var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var keys = [];

  var childNodes = _filterInstanceProperty(data).call(data, function (item) {
    return isChild(item.pos, pos, pos !== item.pos);
  });

  childNodes.forEach(function (item) {
    keys.push(item.key);
  });
  return keys;
};
export var getPos = function getPos(data, key) {
  var node = _findInstanceProperty(data).call(data, function (item) {
    return item.key === key;
  });

  return node === null || node === void 0 ? void 0 : node.pos;
};
export var getInitCheckedKeys = function getInitCheckedKeys(data, keys) {
  var _context3;

  var checkedKeys = [];
  keys.forEach(function (item) {
    var pos = getPos(data, item);
    checkedKeys.push.apply(checkedKeys, _toConsumableArray(getAllChildKeys(data, pos)));
  });
  return _Array$from(new _Set(_concatInstanceProperty(_context3 = []).call(_context3, checkedKeys, _toConsumableArray(keys))));
};
export var getInitCheckededState = function getInitCheckededState(data) {
  var checkedKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var maxLevel = arguments.length > 2 ? arguments[2] : undefined;
  var init = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var _checkedKeys = _toConsumableArray(checkedKeys);

  var _halfCheckedKeys = [];

  var _loop = function _loop(i) {
    data.forEach(function (item) {
      if (item.level === i) {
        var selfChecked = getChecked(_checkedKeys, item.key);

        var _hasChildCheckState = item.hasChildNode && hasChildCheckState(data, _halfCheckedKeys, _checkedKeys, item.pos, item.level, init);

        var _allChildChecked = item.hasChildNode && allChildChecked(data, _checkedKeys, item.pos, item.level, init);

        var _hasChildChecked = _hasChildCheckState === null || _hasChildCheckState === void 0 ? void 0 : _hasChildCheckState.checked;

        var _hasHalfChildChecked = _hasChildCheckState === null || _hasChildCheckState === void 0 ? void 0 : _hasChildCheckState.halfChecked;

        var _hasParentChecked = hasParentChecked(data, checkedKeys, item.pos);

        var checked = selfChecked || _hasParentChecked || _allChildChecked;

        if (checked) {
          _checkedKeys.push(item.key);
        }

        var halfChecked = (_hasChildChecked || _hasHalfChildChecked) && !checked;

        if (halfChecked) {
          _halfCheckedKeys.push(item.key);
        }
      }
    });
  };

  for (var i = maxLevel; i >= 0; i--) {
    _loop(i);
  }

  return {
    checkedKeys: _Array$from(new _Set(_checkedKeys)),
    halfCheckedKeys: _Array$from(new _Set(_halfCheckedKeys))
  };
};
export var getDataCheckededState = function getDataCheckededState(data, checkedKeys, halfCheckedKeys, maxLevel) {
  var init = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var pos = arguments.length > 5 ? arguments[5] : undefined;
  var value = arguments.length > 6 ? arguments[6] : undefined;

  var _checkedKeys = _toConsumableArray(checkedKeys);

  var _halfCheckedKeys = _toConsumableArray(halfCheckedKeys);

  var _loop2 = function _loop2(i) {
    data.forEach(function (item) {
      var selfChecked = getChecked(_checkedKeys, item.key);
      var selfHalfChecked = getChecked(_halfCheckedKeys, item.key);

      var _allChildChecked = item.hasChildNode && allChildChecked(data, _checkedKeys, item.pos, item.level, false);

      var _hasChildCheckState = item.hasChildNode && hasChildCheckState(data, _halfCheckedKeys, _checkedKeys, item.pos, item.level, init);

      var _hasChildChecked = _hasChildCheckState === null || _hasChildCheckState === void 0 ? void 0 : _hasChildCheckState.checked;

      var _hasHalfChildChecked = _hasChildCheckState === null || _hasChildCheckState === void 0 ? void 0 : _hasChildCheckState.halfChecked;

      if (item.level === i) {
        if (item.disabled) return; // 节点被禁用

        if (value) {
          if (!selfChecked) {
            if (isParentNode(item.pos, pos)) {
              _checkedKeys.push(item.key);

              _halfCheckedKeys = delKey(_halfCheckedKeys, [item.key]);
            } else if (isChildNode(item.pos, pos)) {
              if (_allChildChecked) {
                _checkedKeys.push(item.key);
              } else if (_hasChildChecked || _hasHalfChildChecked) {
                _halfCheckedKeys.push(item.key);
              }
            }
          }
        } else {
          if (selfChecked) {
            if (isParentNode(item.pos, pos)) {
              _checkedKeys = delKey(_checkedKeys, [item.key]);
            } else if (isChildNode(item.pos, pos)) {
              if (!_allChildChecked && (_hasChildChecked || _hasHalfChildChecked)) {
                _halfCheckedKeys.push(item.key);
              }

              _checkedKeys = delKey(_checkedKeys, [item.key]);
            }
          } else if (selfHalfChecked) {
            if (!_hasChildChecked && !_hasHalfChildChecked) {
              _halfCheckedKeys = delKey(_halfCheckedKeys, [item.key]);
            }
          }
        }
      }
    });
  };

  for (var i = maxLevel; i >= 0; i--) {
    _loop2(i);
  }

  return {
    checkedKeys: _Array$from(new _Set(_checkedKeys)),
    halfCheckedKeys: _Array$from(new _Set(_halfCheckedKeys))
  };
};
export var getDataCheckededStateStrictly = function getDataCheckededStateStrictly(checkedKeys) {
  var _checkedKeys = _toConsumableArray(checkedKeys);

  return {
    checkedKeys: _Array$from(new _Set(_checkedKeys)),
    halfCheckedKeys: []
  };
};

var isChildNode = function isChildNode(pos, childPos) {
  return isChild(childPos, pos, pos !== childPos);
};

var isParentNode = function isParentNode(pos, childPos) {
  return isChildNode(childPos, pos);
};

export var delKey = function delKey(prevKeys, delKeys) {
  var keys = _extends([], prevKeys);

  delKeys.forEach(function (item) {
    var index = keys.indexOf(item);
    index > -1 && _spliceInstanceProperty(keys).call(keys, index, 1);
  });
  return keys;
};
export var getAllNodeKeys = function getAllNodeKeys(data) {
  var keys = [];
  data.forEach(function (item) {
    keys.push(item.key);
  });
  return keys;
};

var getRootKeys = function getRootKeys(data) {
  var rootKey = '';
  var NO_ROOT = undefined;

  var firstLevelNodes = _filterInstanceProperty(data).call(data, function (item) {
    var _a;

    return ((_a = item.pos) === null || _a === void 0 ? void 0 : _a.indexOf('-')) === -1;
  });

  if (firstLevelNodes.length > 1) return NO_ROOT;
  data.forEach(function (item) {
    if (item.pos === '0') {
      rootKey = item.key;
    }
  });
  return rootKey;
};

export var getInitExpandedKeys = function getInitExpandedKeys(data, expandedKeys, defaultExpandedKeys, defaultExpandAll, defaultExpandRoot, defaultExpandParent) {
  var expandScrollkeys = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var filterTreeNode = arguments.length > 7 ? arguments[7] : undefined;
  var isSearching = arguments.length > 8 ? arguments[8] : undefined;
  var keys = (expandedKeys === null || expandedKeys === void 0 ? void 0 : _concatInstanceProperty(expandedKeys).call(expandedKeys, expandScrollkeys)) || (defaultExpandedKeys === null || defaultExpandedKeys === void 0 ? void 0 : _concatInstanceProperty(defaultExpandedKeys).call(defaultExpandedKeys, expandScrollkeys)) || [];

  if (defaultExpandAll) {
    keys = getAllNodeKeys(data);
  } else {
    if (defaultExpandRoot) {
      var rootKey = getRootKeys(data);

      if (rootKey) {
        keys = _concatInstanceProperty(keys).call(keys, rootKey);
      }
    }

    if (defaultExpandParent) {
      var parentKeys = [];
      keys.forEach(function (key) {
        parentKeys.push.apply(parentKeys, _toConsumableArray(getAllParentKeys(data, key)));
      });
      keys = _concatInstanceProperty(keys).call(keys, parentKeys);
    }
  }

  if (isSearching) {
    var _context4;

    keys = _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(keys), _toConsumableArray(getAllFilterKeys(data, filterTreeNode)));
  }

  return _Array$from(new _Set(_toConsumableArray(keys)));
};
export var getExpandedKeys = function getExpandedKeys(expandedKeys) {
  var expandScrollkeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var keys = (expandedKeys === null || expandedKeys === void 0 ? void 0 : _concatInstanceProperty(expandedKeys).call(expandedKeys, expandScrollkeys)) || [];
  return _Array$from(new _Set(_toConsumableArray(keys)));
};
export var calcDropPosition = function calcDropPosition(event, dropNode) {
  var clientY = event.clientY;

  var _dropNode$getBounding = dropNode.getBoundingClientRect(),
      top = _dropNode$getBounding.top,
      bottom = _dropNode$getBounding.bottom,
      height = _dropNode$getBounding.height;

  if (clientY <= top + height * DRAG_OFFSET) {
    return -1;
  }

  if (clientY >= bottom - height * DRAG_OFFSET) {
    return 1;
  }

  return 0;
};